import _ from "lodash";
import React, { useState } from "react";

import { connect } from "react-redux";
import classNames from "classnames";
import { CHAT_TYPE_ENUM } from "MessagingV2/modules/Utils";
import { Modal, IconButton } from "@toddle-edu/ds-web";
import { TeacherAddOutlined } from "@toddle-edu/ds-icons";
import ViewMembers from "MessagingV2/components/Channels/AddMembersV2/components/ViewMembers";
import { handleRemoveUserFromChannel } from "MessagingV2/modules/MessagingModule";
import { useI18n } from "Hooks";
import { setToastMsg } from "Login/modules/LoginModule/LoginActions";
import { isIdEqual } from "Utils";
import classes from "./ManageMembersModal.scss";
import ChatToChannel from "MessagingV2/components/ChatToChannel";

const styles = {
  addMemberModalBodyStyles: {
    padding: "0px",
    overflow: "hidden",
  },
  modalBodyStyles: {
    paddingTop: "4px",
    paddingRight: "0px",
    overflow: "hidden",
  },
  searchOverlayContainerStyle: {
    maxHeight: "356px",
  },
  emptyStateSubtitleStyle: {
    width: "380px",
  },
};

const MODALS = {
  ADD_MEMBERS_OR_CREATE_CHANNEL_MODAL: "ADD_MEMBERS_OR_CREATE_CHANNEL_MODAL",
  MANAGE_MEMBERS_MODAL: "MANAGE_MEMBERS_MODAL",
};

const ManageMembersModal = props => {
  const {
    onCloseModal,
    users: prevUsers,
    chatId,
    handleRemoveUserFromChannel,
    channelLabel,
    isMemberUpdate,
  } = props;

  const { t } = useI18n(["common"]);

  const [showModalType, setShowModalType] = useState(
    MODALS.MANAGE_MEMBERS_MODAL
  );
  const [selectedAddUsers, setSelectedAddUsers] = useState([]);

  const showAddMemberORCreateUI = () => {
    setShowModalType(MODALS.ADD_MEMBERS_OR_CREATE_CHANNEL_MODAL);
  };

  const onCloseAddMemberUI = () => {
    setShowModalType(MODALS.MANAGE_MEMBERS_MODAL);
  };

  const handleRemoveUserFromViewMode = async ({ user }) => {
    const updatedCurrentUsers = _.filter(prevUsers, u => {
      return !isIdEqual(user.id, u.id);
    });
    handleRemoveUserFromChannel({
      chatId,
      users: updatedCurrentUsers,
      removedUser: user,
    });
  };

  return (
    <>
      {_.isEqual(showModalType, MODALS.MANAGE_MEMBERS_MODAL) ? (
        <Modal
          width={"576px"}
          height="680px"
          isClose={false}
          onClose={onCloseModal}
        >
          <Modal.Header>
            <div className={classes.modalHeaderContainer}>
              <div
                className={classNames("heading-4", classes.manageMemberHeader)}
              >
                {t("common:manage_members_for_label", { label: channelLabel })}
              </div>
            </div>
            {isMemberUpdate ? (
              <div className={classes.addMemberIconContainer}>
                <IconButton
                  icon={<TeacherAddOutlined />}
                  variant={"plain"}
                  onClick={showAddMemberORCreateUI}
                />
              </div>
            ) : null}
          </Modal.Header>
          <Modal.Body style={styles.modalBodyStyles}>
            <ViewMembers
              users={prevUsers}
              updateUsers={setSelectedAddUsers}
              chatId={chatId}
              handleRemoveUser={handleRemoveUserFromViewMode}
              isMemberUpdate={isMemberUpdate}
            />
          </Modal.Body>
        </Modal>
      ) : null}

      {_.isEqual(showModalType, MODALS.ADD_MEMBERS_OR_CREATE_CHANNEL_MODAL) ? (
        <ChatToChannel
          onCloseModal={onCloseAddMemberUI}
          chatId={chatId}
          channelLabel={channelLabel}
          conversationType={CHAT_TYPE_ENUM.CHANNEL_CUSTOM}
          users={prevUsers}
        />
      ) : null}
    </>
  );
};

const mapActionCreators = {
  handleRemoveUserFromChannel,
  setToastMsg,
};

export default connect(null, mapActionCreators)(ManageMembersModal);
